export default __webpack_public_path__ + "static/media/B3_11.529dc143.mp3";